import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import { getUserblogs, getblogCategories } from "../../../Services/APIrequests";
import styles from "./home.module.css";
import resource from "../Blogpage/blog.module.css";
import parse from "html-react-parser";
import defaultIMG from "../../../Assets/defaultimg.png";

const SampleBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const blogsResponse = await getUserblogs();
                const blogsData = blogsResponse.data.blogs || [];

                // Filter blogs to show only those with `homepage: "1"`
                const homepageBlogs = blogsData.filter(
                    (blog) => blog.homepage === "1"
                );

                setBlogs(blogsData);
                setError(null);
            } catch (err) {
                console.error("Error fetching blogs:", err);
                setError("Failed to load blogs. Please try again later.");
                setBlogs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    // Navigate to blog details
    const handleClick = (blogId) => {
        navigate(`/blog/${blogId}`);
    };

    return (
        <div className={styles.sampleblogs_container}>
            <h1 className={styles.samplenlogtext}>Blogs</h1>
            <div className={styles.blags_container}>
                {loading ? (
                    <p className={resource.loadingText}>Loading blogs...</p>
                ) : error ? (
                    <p className={resource.errorText}>{error}</p>
                ) : blogs.length > 0 ? (
                    <div className={resource.cardsubcontainer}>
                        {blogs.map((blog) => (
                            <div
                                key={blog.blogId}
                                className={resource.resourceBox}
                                data-aos="fade-down"
                                data-aos-easing="linear"
                                data-aos-duration="1500"
                                onClick={() => handleClick(blog.blogSlug)}>
                                <div className={resource.imagecontainer}>
                                    <img
                                        src={blog.bigImage}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = defaultIMG;
                                        }}
                                        alt={blog.title || "Blog Image"}
                                        className={resource.rbox_img}
                                    />
                                </div>
                                <h1 className={resource.boxheader}>
                                    {blog.title}
                                </h1>
                                {/* <p className={resource.boxptext}>{parse(blog.shortDescription)}</p> */}
                                <p className={resource.boxptext}>
                                    {typeof blog.shortDescription ===
                                        "string" && blog.shortDescription.trim()
                                        ? parse(blog.shortDescription)
                                        : "No description available."}
                                </p>

                                <div className={resource.boxbtncontainer}>
                                    <p className={resource.readtext}>
                                        Read More
                                    </p>
                                    <button
                                        type="button"
                                        className={resource.btn}
                                        onClick={() =>
                                            handleClick(blog.blogId)
                                        }>
                                        <FaArrowRightLong size={15} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className={resource.noBlogsText}>
                        No blogs available for the homepage.
                    </p>
                )}
            </div>
        </div>
    );
};

export default SampleBlogs;
